import {createContext, ReactElement} from "react";
import { Host } from "../../host/host";

const HostServices = new Host();
const HostContext = createContext<Host>(HostServices);

HostServices.initialise().catch(console.error);

interface IHostProvider {
    children: ReactElement | ReactElement []
}
function HostProvider({children}: IHostProvider) {
    return (
        <HostContext.Provider value={HostServices}>
            <>
                {children}
            </>
        </HostContext.Provider>
    );
}

export {HostContext, HostProvider, HostServices};